import React, { Component } from 'react'
import { Popup, Form } from 'devextreme-react'
import { getUser } from 'dataSource/lookup'
import httpRequest from 'plugin/httprequest'
import { confirm } from 'devextreme/ui/dialog'
import notify from 'devextreme/ui/notify'

class ModalEditUser extends Component {
  constructor(props) {
    super(props)

    this.participantId = this.props.store.getState().sessionUser
      ? this.props.store.getState().sessionUser.participantId
      : 0

    this.state = {
      popupVisible: false,
      dataMaster: {},
      actionType: null,
    }

    this.show = this.show.bind(this)
    this.hide = this.hide.bind(this)

    this.formRef = React.createRef()

    this.PopupToolbarItem = [
      {
        widget: 'dxButton',
        location: 'after',
        options: {
          text: 'Simpan',
          elementAttr: { class: 'bg-button-popup-save-dapen-default' },
          onClick: async () => {
            let confirms = await confirm(
              'Apakah anda ingin menyimpan data ini ?',
              'Konfirmasi'
            )
            if (confirms) {
              await this.submitData()
            }
          },
        },
        toolbar: 'bottom',
      },
      {
        widget: 'dxButton',
        location: 'after',
        options: {
          text: 'Batal',
          elementAttr: { class: 'bg-button-popup-close-dapen-default' },
          onClick: this.hide.bind(this),
        },
        toolbar: 'bottom',
      },
    ]

    this.form = [
      {
        dataField: 'username',
        label: {
          text: 'Username',
        },
        editorOptions: {
          elementAttr: { class: 'bd-input-popup-dapen-default' },
          placeholder: 'Username',
        },
      },
      {
        dataField: 'firstName',
        label: {
          text: 'Nama Awal',
        },
        editorOptions: {
          elementAttr: { class: 'bd-input-popup-dapen-default' },
          placeholder: 'Nama Awal',
        },
      },
      {
        dataField: 'lastName',
        label: {
          text: 'Nama Akhir',
        },
        editorOptions: {
          elementAttr: { class: 'bd-input-popup-dapen-default' },
          placeholder: 'Nama Akhir',
        },
      },
      {
        dataField: 'email',
        label: {
          text: 'Email',
        },
        editorOptions: {
          elementAttr: { class: 'bd-input-popup-dapen-default' },
          placeholder: 'Email',
        },
      },
      {
        dataField: 'userParentId',
        label: {
          text: 'Supervisor',
        },
        editorType: 'dxSelectBox',
        editorOptions: {
          elementAttr: { class: 'bd-input-popup-dapen-default' },
          dataSource: getUser(this.props.store, this.participantId),
          valueExpr: 'id',
          displayExpr: 'username',
          searcEnabled: true,
        },
      },
      // {
      //     dataField: 'activated',
      //     label: {
      //         text: 'Status'
      //     },
      //     editorType: 'dxCheckBox',
      // }
    ]
  }

  show = (data, type) => {
    let datas
    if (data) {
      datas = data
    } else {
      datas = {}
    }

    this.setState({
      popupVisible: true,
      dataMaster: datas,
      actionType: type,
    })
  }

  hide = () => {
    this.setState({
      popupVisible: false,
      dataMaster: {},
      actionType: null,
    })
  }

  submitData = async () => {
    const dataMaster = this.state.dataMaster

    try {
      if (this.state.actionType === 'add') {
        const param = {
          ...dataMaster,
          login: dataMaster.username,
          participantId: this.props.store.getState().sessionUser.participantId,
          password: 'Cakra123$',
        }

        await httpRequest(
          process.env.REACT_APP_BACKEND,
          this.props.store,
          'wp/participant/account',
          'POST',
          {
            values: param,
          }
        )
      } else {
        const param = {
          ...dataMaster,
          login: dataMaster.username,
          participantId: this.props.store.getState().sessionUser.participantId,
          password: 'Cakra123$',
        }

        await httpRequest(
          process.env.REACT_APP_BACKEND,
          this.props.store,
          'wp/participant/account',
          'PUT',
          {
            key: param.id,
            values: param,
          },
          dataMaster
        )
      }

      this.hide()
      notify(
        {
          message: 'Berhasil Kirim Data!',
          width: 'AUTO',
          shading: true,
          position: { at: 'center', my: 'center', of: window },
        },
        'success',
        1000
      )
      this.props.forceRefresh()
    } catch (e) {
      console.log(e)
      notify(
        {
          message: 'Internal Server Error!',
          width: 'AUTO',
          shading: true,
          position: { at: 'center', my: 'center', of: window },
        },
        'error',
        1000
      )
    }
  }

  render() {
    return (
      <Popup
        className={'popup'}
        visible={this.state.popupVisible}
        onHiding={this.hide}
        dragEnabled={false}
        showTitle={true}
        title={
          this.state.actionType === 'add'
            ? 'Form Tambah User'
            : 'Form Ubah User'
        }
        width={700}
        height={'auto'}
        toolbarItems={this.PopupToolbarItem}
        ref={this.PopupRef}
      >
        <Form
          ref={this.formRef}
          colCount={1}
          id={'formPotongan'}
          formData={this.state.dataMaster}
          items={this.form}
          labelLocation="left"
        />
      </Popup>
    )
  }
}

export default ModalEditUser
